import { AuthMode } from '../auth/auth-mode.constant';
import { FiatCurrency } from '../shared/finance';

import { Environment } from './environment.abstraction';

export const environment: Environment = {
  production: false,
  apiHost: '/api',
  auth: {
    corporateSsoEnabled: true,
    mode: AuthMode.SessionManager,
    sessionManagerHost: '',
  },
  defaultLang: 'en',
  hrServicesEnabled: true,
  jiraAttachmentsEnabled: true,
  notificationsPollingIntervalMs: 20_000,
  sourceMap: true,
  supportedUiLanguages: ['en'],
  theme: 'light',
  defaultCurrency: FiatCurrency.EUR,
};
